module.exports = __webpack_public_path__ + "img/kp-logo-reverse.f51ead67.png";